/** Main project script */
'use strict';


import {createApp} from 'vue';
import useCollapse from "./composables/collapser";
import CarouselHolder from './components/carousel-holder';
import CardCarousel from './components/card-carousel';
import SuggestiveSearch from './components/suggestive-search';
import MapBox from './components/map-box';
import SinglePinMap from './components/single-pin-map';
import MultiPinMap from './components/multi-pin-map';
import MenuHandler from './components/menu-handler';

import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js';
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css';

import autoComplete from "@tarekraafat/autocomplete.js";

import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client/core';

var link = window.solout.baseUrl.split('/');
link.push('graphql');
link = link.filter(function (el) {
    if (el === null || el === undefined || el === "" || !el || el === " ") {
        return false;
    }
    return true;
});

link = '/' + link.join('/');

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: link,
});

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
});

import {createApolloProvider} from '@vue/apollo-option'

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
})

//  end graphql
const toggleLightbox = (index) => {
    indexRef.value = index
    visibleRef.value = true
}

const app = createApp({
    components: {
        CarouselHolder,
        CardCarousel,
        SuggestiveSearch,
        MapBox,
        SinglePinMap,
        MultiPinMap,
        MenuHandler,
        VueEasyLightbox
    },
    setup () {
        useCollapse();
    },
    // Shared app state
    data() {
        return {
            navigation: {
                open: false,
                openSubMenu: 0,
                mobileMenuOpen: false,
                mobileMenuSubMenu: 0,
                searchBarOpen: false
            },
            minPageHeight: null,
            scrolled: false,
            lightboxVisibleRef: null,
            lightboxIndexRef: null,
            filterMenuOpen: false,
            searchColumn: 'filter'
        };
    },
    methods: {
        handleScroll: function () {
            if (window.scrollY > 44) {
                // The screen is scrolled down more than 44 pixels from the top
                this.scrolled = true;
            } else {
                // The screen is at the top or close to it
                this.scrolled = false;
            }
        },
        fixSearchBar: function (action) {
            if (action === 'open') {
                this.navigation.searchBarOpen = true;
            } else {
                this.navigation.searchBarOpen = false;
            }
        },
        toggleSearchBar: function () {
            this.navigation.mobileMenuOpen = false;
            this.navigation.searchBarOpen = !this.navigation.searchBarOpen;
        },
        toggleSubmenu: function (id) {

            if (this.navigation.openSubMenu === id) {
                this.navigation.openSubMenu = 0;
            } else {
                this.navigation.openSubMenu = id;
            }
        },
        fixMobileMenu: function (action) {
            if (action === 'open') {
                this.navigation.mobileMenuOpen = true;
            } else {
                this.navigation.mobileMenuOpen = false;
            }
        },
        toggleMobileMenu: function (id) {
            this.navigation.searchBarOpen = false;
            this.navigation.mobileMenuOpen = !this.navigation.mobileMenuOpen;
        },
        toggleMobileSubmenu: function (id) {
            if (this.navigation.mobileMenuSubMenu === id) {
                this.navigation.mobileMenuSubMenu = 0;
            } else {
                this.navigation.mobileMenuSubMenu = id;
            }
        },
        toggleLightbox: function (index) {
            this.lightboxIndexRef = index;
            this.lightboxVisibleRef = true;
        },
        goTo: function (url, newTab) {
            if (!url) {
                return false;
            }
            newTab = newTab || false;
            if (newTab) {
                return window.open(url);
            }
            return window.location.href = url;
        },
        setupScrollHelper: function () {
            let targets = document.querySelectorAll('[data-scrollhelper]');
            // loop through the targets
            const options = {
                root: null,
                threshold: 0.2
            };

            for (let i = 0; i < targets.length; i++) {
                let preset = targets[0].dataset?.presetClass?.trim().split(' ');
                let parent = targets[0].closest('section');
                parent.classList.add('animation-parent');
                if (preset) {
                    preset.forEach(value => targets[i].classList.add(value));
                    // targets[0].classList.add(preset.join[',']);
                }
            }

            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // process:
                        let me = entry.target;

                        let cssClass = me.dataset?.class?.trim().split(' ');

                        if (cssClass) {
                            cssClass.forEach(value => me.classList.add(value));
                            // me.classList.add(cssClass);
                        }

                        me.classList.add("appear-on-scroll");
                        observer.unobserve(me);
                    } else {
                        return;
                    }
                });
            }, options);

            targets.forEach(target => observer.observe(target));

        },
        scrollHelper: function (el, elClass, offset, callback) {
        },
        toggleParentClass: function (parentSelector, className, method) {
            if (method === 'add') {
                document.querySelector(parentSelector).classList.add(className);
            } else {
                document.querySelector(parentSelector).classList.remove(className);
            }
        },
        toggleFilterMenu: function () {
            this.filterMenuOpen = !this.filterMenuOpen;
        },
        applyFilterSort: function (e) {
            const fieldValue = e.target.value;

            const sortInputs = document.querySelectorAll('[name="Sort"]');
            sortInputs.forEach(input => {
                input.value = fieldValue;
            });

            const form = document.querySelector('#Form_FilterPracForm');
            form.submit();
        },
        clearFilterFields: function () {
            const searchForm = document.querySelector('#Form_SearchPracForm');
            this.clearForm(searchForm);

            const filterForm = document.querySelector('#Form_FilterPracForm');
            this.clearForm(filterForm);
        },
        clearForm: function (form) {
            form.reset();

            const textFields = form.querySelectorAll('input[type="text"]');
            textFields.forEach(textField => {
                textField.value = '';
            });

            const checkboxes = form.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });

            const dropdowns = form.querySelectorAll('select');
            dropdowns.forEach(dropdown => {
                dropdown.value = '';
            });

            window.history.replaceState(null, '', window.location.pathname);
        },
        swapSearchColumn: function (columnName) {
            this.searchColumn = columnName;
        },
        initAutocomplete: function () {
            const searchField = document.querySelector('#Form_SearchPracForm_Name');
            if (!searchField) {
                return;
            }

            const nameArray = solout.practitionerNames;
            if (!nameArray || nameArray.length === 0) {
                return;
            }

            const autoCompleteJS = new autoComplete({
                selector: "#Form_SearchPracForm_Name",
                data: {
                    src: nameArray,
                    cache: true,
                },
                resultItem: {
                    highlight: true
                },
                events: {
                    input: {
                        selection: (event) => {
                            const selection = event.detail.selection.value;
                            autoCompleteJS.input.value = selection;
                        }
                    }
                }
            });

            const urlParams = new URLSearchParams(window.location.search);
            const nameParam = urlParams.get('Name');
            if (nameParam) {
                searchField.value = nameParam;
            }
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll;
        // this.handleDebouncedScroll = debounce(this.handleScroll, 100);
        // window.addEventListener('scroll', this.handleScroll);

    },
    mounted() {
        this.setupScrollHelper();
        this.initAutocomplete();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
});

app.config.globalProperties.location = window.location;
app.use(apolloProvider);
app.mount('#tw_app');
